import { useEffect, useState } from "react";
import { useSelector } from "react-redux";

import EmptySearchIcon from "../icons/empty-search-icon";
import ReastartIcon from "../icons/restart-icon";
import SearchIcon from "../icons/search-icon";
import DownloadIcon from "../icons/download-icon";
import CopyIcon from "../icons/copy-icon";
import constant from "./utils/constant";
import { CustomAudio } from "./Common";
import {
  convertToPersianNumber,
  second_to_time,
  time_to_second,
} from "./utils/functions";
import EditIcon from "../icons/edit-icon";
import TickIcon from "../icons/tick-icon";
import CloseIcon from "../icons/close-icon";
import { patchRequest, summarizeRequest } from "../Archive/data";
import SummarizeIcon from "../icons/summarize-icon";
import Search2Icon from "../icons/search2-icon";
import { errorNotify, successNotify } from "../notify/toastify";

const ResponseNew = (props) => {
  const { finalResponse, wsConnected, isArchive, onClickFunc } = props;
  const searchVal = useSelector((state) => state.search.searchVal);
  const [clickedTextTime, setClickedTime] = useState(null);
  const [currentTime, setCurrentTime] = useState(0);
  const [searchValue, setSearchValue] = useState("");
  const [searchResult, setSearchResult] = useState([]);
  const [segmentClicked, setSegmentClicked] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [isSummarize, setIsSummarize] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [summarizeText, setSummarizeText] = useState("");
  const icons_names = constant.ICON_NAMES;
  const url = isArchive ? finalResponse.url : finalResponse.download_url;
  const fileExtension = url.split(".").pop();
  const fileName =
    finalResponse.filename === `.${fileExtension}` ||
      finalResponse.filename === "" ||
      finalResponse.filename == null ||
      finalResponse.filename == undefined
      ? url.split("/").pop()
      : finalResponse.filename.split(".").slice(0, -1).join(".");
  const [fileEdit, setFileEdit] = useState(fileName);
  const final_response = {
    segments: finalResponse.segments || [],
    download_url:
      finalResponse.download_url ||
      finalResponse.url ||
      finalResponse.media_url ||
      finalResponse.file_url ||
      "",
    duration: finalResponse.duration,
    segmentId: finalResponse.segmentId,
  };

  // from main search in archive
  useEffect(() => {
    if (searchVal.length >= 1) {
      setSearchValue(searchVal);
      const results = final_response.segments.filter((segment) =>
        segment?.text.toLowerCase().includes(searchVal.toLowerCase())
      );

      const segmentIndex = final_response.segmentId;
      const activeResult = final_response.segments[segmentIndex];
      const activeSegmentIndex = results.findIndex(
        (item) => item.numStart === activeResult.numStart
      );

      if (results) {
        setSearchResult(results);
        segmentClickHandler(activeResult.numStart, activeSegmentIndex);
      }
    }
  }, [searchVal]);

  const _handle_copy_txt = () => {
    const speakerLabel = (speaker) => {
      if (!speaker) return "";
      if (speaker.startsWith("SPEAKER_") || speaker.startsWith("speaker_")) {
        const n = parseInt(speaker.split("_")[1], 10);
        if (!Number.isNaN(n)) {
          return `گوینده ${convertToPersianNumber(n + 1)}: `;
        }
      }
      return `${speaker}: `;
    };

    const simple_texts = final_response.segments
      .filter((s) => s && (s.text || s.speaker))
      .map((s) => {
        const text = (s.text || "").trim();
        if (!text) return "";
        return `${speakerLabel(s.speaker)}${text}`;
      })
      .filter(Boolean)
      .join("\n");

    if (!simple_texts) {
      errorNotify({ text: "متنی برای کپی وجود ندارد" });
      return;
    }

    if (navigator.clipboard) {
      navigator.clipboard.writeText(simple_texts).then(
        () => successNotify({ text: "با موفقیت کپی شد" }),
        () => errorNotify({ text: "کپی انجام نشد" })
      );
    } else {
      let input_text = document.body.appendChild(document.createElement("input"));
      input_text.value = simple_texts;
      input_text.focus();
      input_text.select();
      input_text.setSelectionRange(0, 99999);
      document.execCommand("copy");
      input_text.parentNode.removeChild(input_text);
      successNotify({ text: "با موفقیت کپی شد" });
    }
  };

  const downloadHandler = () => {
    const tag = document.createElement("a");
    tag.setAttribute("href", final_response.download_url);
    tag.setAttribute("target", "_blank");
    tag.setAttribute("rel", "noopener noreferrer");
    tag.click();
  };

  final_response.segments.forEach((segment) => {
    // save start and end as seconds by add numStart and numEnd
    segment.numStart = time_to_second(segment.start);
    segment.numEnd = time_to_second(segment.end);
    // Standardize start and end time for show in render
    segment.start = second_to_time(segment.numStart);
    segment.end = second_to_time(segment.numEnd);
  });

  const active_segment_obj = final_response.segments?.filter((segment) => {
    return (segment.numStart && segment.numEnd) === undefined
      ? false
      : segment.numStart <= currentTime && currentTime < segment.numEnd;
  })[0];
  final_response.segments?.forEach((segment) => {
    segment.active = "";
  });

  if (active_segment_obj) active_segment_obj.active = "active";

  const searchHandler = (event) => {
    setSearchValue(event.target.value);
    if (event.target.value.length >= 3) {
      const results = final_response.segments.filter((segment) =>
        segment?.text.toLowerCase().includes(event.target.value.toLowerCase())
      );
      results && setSearchResult(results);
    } else {
      setSearchResult([]);
    }
    setSegmentClicked(null);
  };

  const highlightSearch = (item, index2) => {
    const regex = new RegExp(`(${searchValue})`, "gi");
    const parts = item.split(regex);

    return parts.map((part, index) =>
      regex.test(part) ? (
        <strong
          key={index}
          style={
            segmentClicked === index2
              ? { color: "white" }
              : { color: "#000000" }
          }
        >
          {part}
        </strong>
      ) : (
        part
      )
    );
  };

  const segmentClickHandler = (numStart, index) => {
    setClickedTime(numStart);
    setSegmentClicked(index);
  };

  const openEdit = () => {
    setIsEdit(true);
  };

  const closeEdit = () => {
    setIsEdit(false);
    setFileEdit(fileName);
  };

  const changeFilename = (e) => {
    setFileEdit(e.target.value);
  };

  const handleEdit = async () => {
    try {
      await patchRequest({
        id: props.finalResponse.id,
        filename: fileEdit,
        prefix: fileExtension,
      });
      setIsEdit(false);
      successNotify({ text: "با موفقیت ویرایش شد" });
      setTimeout(() => {
        window.location.reload();
      }, 2000);
    } catch (error) {
      errorNotify({ text: error.detail });
    }
  };

  const handleSummarize = async () => {
    setIsLoading(true);
    try {
      const data = await summarizeRequest({
        download_url: final_response.download_url,
      });
      setSummarizeText(data.result);
      setIsLoading(false);
    } catch (error) {
      errorNotify({ text: error.error });
      setIsLoading(false);
    }
  };
  
  return (
    <div className="response-new">
      <div className="response-new-left">
        <div className="response-new-left-top">
          {isArchive && (
            <div
              className="response-edit-filename"
              style={isEdit ? { width: "100%" } : {}}
            >
              {!isEdit ? (
                <>
                  <span
                    style={{
                      cursor: "pointer",
                      backgroundColor: "#F0F0F0",
                      width: "25px",
                      height: "25px",
                      borderRadius: "5px",
                      paddingRight: "0.35rem",
                    }}
                  >
                    <EditIcon height={13} width={13} onClick={openEdit} />
                  </span>
                  <span
                    style={{
                      maxWidth: "10rem",
                      marginLeft: "0.5rem",
                      direction: "rtl",
                    }}
                  >
                    {fileName.length > 15
                      ? `${fileName.slice(0, 15)} ...`
                      : fileName}
                  </span>
                </>
              ) : (
                <div style={{ direction: "rtl" }}>
                  <span>
                    <input
                      className="edit-input"
                      type="text"
                      onChange={(e) => changeFilename(e)}
                      value={fileEdit}
                      style={{ textOverflow: "ellipsis" }}
                    ></input>
                  </span>
                  <TickIcon
                    width={10}
                    height={9}
                    style={{
                      cursor: "pointer",
                      marginRight: "1rem",
                      marginLeft: "0.5rem",
                    }}
                    onClick={handleEdit}
                  />
                  <CloseIcon
                    height={10}
                    width={9}
                    color={"#939393"}
                    style={{ cursor: "pointer" }}
                    onClick={closeEdit}
                  />
                </div>
              )}
            </div>
          )}
        </div>
        <div className="response-thumbnail">
          <div className="active-text" dir="rtl">
            {/* TODO: add active_segment_obj.speaker */}
            {active_segment_obj && active_segment_obj.speaker && (
              <span className="speaker">
                {active_segment_obj.speaker.startsWith("SPEAKER_") ||
                  active_segment_obj.speaker.startsWith("speaker_")
                  ? `گوینده ${convertToPersianNumber(
                    parseInt(active_segment_obj.speaker.split("_")[1]) + 1
                  )} :`
                  : active_segment_obj.speaker}
              </span>
            )}
            <span className="speaker-text">
              {active_segment_obj && active_segment_obj.text}
            </span>
          </div>
        </div>
        <div className="custom-audio-container">
          <CustomAudio
            src={final_response.download_url}
            controls={true}
            autoPlay={false}
            setCurrentTime={setCurrentTime}
            clickedTextTime={clickedTextTime}
            duration={final_response.duration}
            wsConnected={wsConnected}
            classNames="custom-audio"
          />
        </div>
        <div className="response-tools">
          <button className="copy" onClick={_handle_copy_txt}>
            کپی متن
            <CopyIcon width={19} height={21} color="#606060" />
          </button>
          <button className="download" onClick={downloadHandler}>
            دانلود فایل
            <DownloadIcon width={15} height={16} color="#FAFAFA" />
          </button>
          {!isArchive && (
            <button
              className="restart"
              onClick={() => onClickFunc(icons_names.RESTART)}
            >
              شروع دوباره
              <ReastartIcon width={13} height={14} />
            </button>
          )}
        </div>
      </div>
      <div className="response-new-right">
        <div
          className="search-box"
          style={{ width: "225px", position: "absolute", right: "5px" }}
        >
          <input
            className="search-input"
            type="text"
            style={{ width: "70%" }}
            placeholder="جست‌و‌جو  ..."
            disabled={isSummarize ? true : false}
            dir="auto"
            value={searchValue}
            onChange={searchHandler}
          />
          <Search2Icon width={20} height={20} color="#00BA9F" />
        </div>
        <div
          className="summarize-button"
          onClick={() => {
            setIsSummarize(!isSummarize);
            if (!isSummarize && summarizeText === "") {
              handleSummarize();
            }
          }}
          style={isSummarize ? { background: "#00BA9F" } : {}}
        >
          <p
            style={
              isSummarize
                ? {
                  color: "#ffffff",
                  fontSize: "12px",
                  marginRight: "0.2rem",
                  marginTop: "1rem",
                }
                : {
                  color: "#626262",
                  fontSize: "12px",
                  marginRight: "0.2rem",
                  marginTop: "1rem",
                }
            }
          >
            خلاصه سازی
          </p>
          {isSummarize ? (
            <SummarizeIcon width={18} height={18} step={2} />
          ) : (
            <SummarizeIcon width={18} height={18} step={1} />
          )}
        </div>
        {isSummarize ? (
          <div className="summarize">
            <div className="summarize-header">
              <span
                style={{
                  background: "#e5f8f5",
                  color: "#00BA9F",
                  width: "105px",
                  height: "30px",
                  fontSize: "12px",
                  padding: "5px 10px",
                  borderRadius: "25px",
                }}
              >
                متن خلاصه شده
              </span>
            </div>

            {isLoading ? (
              <div
                className="response-new no-padding"
                style={{ marginTop: "6rem" }}
              >
                <div className="atom-spinner">
                  <div className="spinner-inner">
                    <div className="spinner-line"></div>
                    <div className="spinner-line"></div>
                    <div className="spinner-line"></div>
                    <div className="spinner-circle">&#9679;</div>
                  </div>
                </div>
              </div>
            ) : (
              <div className="summarize-text" dir="rtl">
                <div style={{ textAlign: "justify" }}>{summarizeText}</div>
              </div>
            )}
          </div>
        ) : (
          <>
            {searchResult.length !== 0 ? (
              <div className="search-results-container">
                <div className="search-result">
                  {searchResult.map((segment, index) => {
                    return (
                      <div
                        key={index}
                        className="result"
                        onClick={() =>
                          segmentClickHandler(segment.numStart, index)
                        }
                        style={
                          segmentClicked === index
                            ? { backgroundColor: "#00BA9F", color: "white" }
                            : {}
                        }
                      >
                        <span>{convertToPersianNumber(segment.start)}</span>
                        <span>{highlightSearch(segment.text, index)}</span>
                      </div>
                    );
                  })}
                </div>
                <section className="spacer" />
                <div className="total-search-result">
                  <span>&nbsp;تعداد</span>
                  <span className="active">
                    &nbsp;{searchResult.length}&nbsp;
                  </span>
                  <span>لغت</span>
                  <span className="active">&nbsp;”{searchValue}”&nbsp;</span>
                  <span>یافت شد</span>
                </div>
              </div>
            ) : (
              <div className="empty-rearch">
                <EmptySearchIcon width={69} height={47} />
                <p>
                  ویژگی مورد نظر خود را از نوار ابزار بالا <span>انتخاب </span>
                  کنید
                </p>
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default ResponseNew;
